import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/educator/courses/$courseId/')({
	component: Outlet,
	beforeLoad: () => {
		return redirect({
			from: '/educator/courses/$courseId',
			to: './apps',
		})
	},
})
